import { onBeforeMount } from "vue";
import Query from "@/shared/utils/router/query";
import { localStorageService, STORAGE_KEY } from "@/shared/connection/local-storage.service";
import { useStore } from "vuex";

const reloadSelf = () => (window.location.href = window.location.pathname);

export const useUserAuth = () => {
    onBeforeMount(async () => {
        const store = useStore();
        const query = new Query(window.location.search);
        const uid = localStorageService.readValue(STORAGE_KEY.userId);

        localStorageService.subscribeOnChange(STORAGE_KEY.userId, () => {
            // Refresh page every other tab changes storage value:
            console.warn("Changes made, reloading user.");
            reloadSelf();
        });

        // merge accounts after email login/register
        const mergeId = Number(query.get("merge"));
        if (mergeId && mergeId !== uid) {
            await store.dispatch("mergeUser", { userId: uid, oldUserId: mergeId });
        }
        await store.dispatch("getUser");
    });
};
